<template>
  <div>
    <a-modal :visible="modalVisible" :title="data" :closable="false" :width="1500" ok-cancel="false" @cancel="closeModal">
      <a-table
        :columns="modalDataColumns"
        :data-source="tableData"
        :pagination="pagination"
        row-key="case_id"
        @change="handleTableChange"
      />
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
export default
{
  data() {
    return {
      modalVisible: false,
      data: [],
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100'],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`,
        size: 'middle'
      },
      modalDataColumns: [
        {
          title: '用例ID',
          dataIndex: 'case_id',
          scopedSlots: { customRender: 'caseId' }
        },
        {
          title: '用例名称',
          dataIndex: 'case_name',
          scopedSlots: { customRender: 'caseName' }
        },
        {
          title: '用例路径',
          dataIndex: 'case_path',
          scopedSlots: { customRender: 'casePath' }
        },
        {
          title: '创建人',
          dataIndex: 'nickname',
          width: 90,
          scopedSlots: { customRender: 'nickName' }
        },
        {
          title: '创建时间',
          dataIndex: 'created_time',
          width: 150,
          scopedSlots: { customRender: 'createdTime' }
        },
        {
          title: '更新时间',
          dataIndex: 'updated_time',
          width: 150,
          scopedSlots: { customRender: 'updatedTime' }
        }
      ]
    };
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    showModal(getData, getTableData) {
      this.modalVisible = true;
      this.data = getData;
      this.tableData = getTableData;
    },
    handleTableChange(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
      // 触发事件让父组件获取新数据
      this.$emit('page-change', pagination);
    }
  }
};
</script>
